import { motion } from "framer-motion";

export function SplashLoadingDots() {
  return (
    <motion.div
      className="mt-8 flex items-center gap-2"
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      aria-hidden="true"
    >
      {[0, 1, 2].map((index) => (
        <motion.span
          key={index}
          className="h-2.5 w-2.5 rounded-full bg-[#8F14E5]"
          initial={{ opacity: 0.25, scale: 0.9 }}
          animate={{ opacity: [0.25, 1, 0.25], scale: [0.9, 1.15, 0.9] }}
          transition={{
            duration: 1.15,
            delay: index * 0.18,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </motion.div>
  );
}
